var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDriveCardIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7578 10.8065H17.4932C17.1177 9.35223 16.3418 8.0324 15.2536 6.99703C14.1655 5.96165 12.8088 5.25225 11.3376 4.94942C9.86643 4.6466 8.33982 4.76251 6.93123 5.28396C5.52264 5.80542 4.28856 6.71152 3.36921 7.89931C2.44987 9.0871 1.88212 10.5089 1.73048 12.0033C1.57884 13.4976 1.8494 15.0045 2.5114 16.3528C3.17341 17.701 4.20031 18.8366 5.47544 19.6304C6.75056 20.4241 8.22277 20.8443 9.72478 20.8432H18.7578C20.0887 20.8432 21.3652 20.3145 22.3063 19.3734C23.2474 18.4323 23.7761 17.1558 23.7761 15.8249C23.7761 14.4939 23.2474 13.2175 22.3063 12.2764C21.3652 11.3353 20.0887 10.8065 18.7578 10.8065Z",
    fill: "url(#paint0_linear_1197_13258)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7383 8.79919V12.8139",
    stroke: "white",
    strokeWidth: 1.40513,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7383 16.8285H12.7483",
    stroke: "white",
    strokeWidth: 1.40513,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1197_13258",
    x1: 7.21746,
    y1: 6.29005,
    x2: 12.7328,
    y2: 20.8432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AD87FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1FD7FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriveCardIcon2);
export default __webpack_public_path__ + "static/media/drive_card_icon2.d337d3b911bc34d4fa6c3bc325a729ca.svg";
export { ForwardRef as ReactComponent };